export default class InputType {
  constructor({ key, scroll }) {
    this.type = 'input';
    this.key = key;
    this.scroll = scroll;
  }
}
